import { z } from "zod/v4";

import { patch } from "./Patch";

export const stateTransaction = z.object({
	id: z.string(),
	lastVersionSeen: z.number(),
	patches: z.array(patch),
	extras: z.unknown().optional(),
});

export type StateTransaction = z.infer<typeof stateTransaction>;
